<span class="lblHeader newHeader">Bank Reconciliation Print</span>
<div class="container" id="Reconciliation" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%; font-family: Calibri;">
        <!--Header-->
        <div class="row"> 
            <div class="col-md-12" style="text-align: center;margin-top: 20px;">
                <span style="font-size: 20px">{{AgencyName}}</span><br>
                <span style="font-size: 13px;">{{City ? City + ',' : ''}} {{State}}</span><br>   
                <span style="font-size: 20px; font-weight: bold;"> {{ bankName }} </span><br>  
                <span style="font-size: 20px;">Reconciliation Statement</span><br>  
                <span style="font-size: 13px;"> {{ FDT | date: 'dd-MMM-yyyy'}} to {{ TDT  | date: 'dd-MMM-yyyy'}} </span><br> 
            </div>
        </div>
            <!--Table + Webview-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 25px;">
                <table class="table table-bordered tblList">
                    <thead>
                        <tr style="text-align: left;">
                            <th class="th-fontstyle" style="width: 8%;">Voucher Date</th>
                            <th class="th-fontstyle" style="width: 8%;">Voucher No.</th>
                            <th class="th-fontstyle" style="width: 10%;">Payment Mode</th>
                            <th class="th-fontstyle" style="width: 10%;">Payment Ref.</th>
                            <th class="th-fontstyle" style="width: 20%;">Ledger</th>
                            <th class="th-fontstyle" style="width: 10%;">Credit</th>
                            <th class="th-fontstyle" style="width: 10%;">Debit</th>
                            <th class="th-fontstyle" style="width: 12%;">Balance</th>
                            <th class="th-fontstyle" style="width: 10%;">Recon. Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!--List-->
                        <tr *ngFor="let R of tempdata;">
                            <!--voucher. Date-->
                            <td class="fontstyle">
                                <span>{{R.EffectiveDate | date: 'dd-MMM-yy' }}</span>
                            </td>
                            <!-- voucher number -->
                            <td class="fontstyle">
                                <span>{{R.VoucherNum}}</span>
                            </td>
                            <!--payment mode-->
                            <td class="fontstyle">
                                <span>{{R.PaymentMode != "0" ? R.PaymentMode : '-'}}</span>
                            </td>
                            <!--Payment Ref-->
                            <td class="fontstyle">
                                <span>{{R.PaymentRef != "" ? R.PaymentRef : '-'}}</span>
                            </td>
                             <!-- Instrument Date-->
                             <td class="fontstyle">
                                <span>{{R.MainLedger}}</span>
                            </td>
                            <!--Credit-->
                             <td class="fontstyle" style="text-align: right;">
                                <span>{{R.CrAmt | lacFormat}}</span>
                            </td>
                            <!--Debit -->
                            <td class="fontstyle" style="text-align: right;">
                                <span>{{R.DbAmt | lacFormat}}</span>
                            </td>
                             <!--balance -->
                            <td class="fontstyle" style="text-align: right;">
                                <span>{{R.CloBal | lacFormat}}</span>
                            </td>
                            <!--Reconc. date -->
                            <td class="fontstyle">
                                <span>{{R.ReconDate | date: 'dd-MMM-yy'}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
      </div>
  </div>
